// App.js - Updated: Jan 2026
import React from 'react';
import {
  BrowserRouter as Router,
  Routes,
  Route,
  useLocation,
} from 'react-router-dom';

import HomePage from './pages/HomePage';
import AdminDashboard from './pages/AdminDashboard';
import LoginPage from './pages/LoginPage';
import MobileDetailPage from './pages/MobileDetailPage';
import CartPage from './pages/CartPage';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';
import EditMobilePage from './pages/EditMobilePage';
import ShortLinkRedirect from './pages/ShortLinkRedirect';
import AboutUsPage from './pages/AboutUsPage';
import ContactPage from './pages/ContactPage';
import FAQPage from './pages/FAQPage';
import BrandsPage from './pages/BrandsPage';
import ComparePage from './pages/ComparePage';
import DealsPage from './pages/DealsPage';
import PrivacyPolicyPage from './pages/PrivacyPolicyPage';
import SellPhonePage from './pages/SellPhonePage';
import RepairPhonePage from './pages/RepairPhonePage';
import TermsOfServicePage from './pages/TermsOfServicePage';
import { SearchProvider } from './context/SearchContext';
import { UserTypeProvider } from './context/UserTypeContext';
import { ThemeProvider } from './context/ThemeContext';
import { HelmetProvider } from 'react-helmet-async';

import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';

import './index.css';
import './styles/darkMode.css';

import ReactGA from "react-ga4";

// Initialize GA4
const MEASUREMENT_ID = process.env.REACT_APP_GA_MEASUREMENT_ID;
if (MEASUREMENT_ID) {
  try {
    ReactGA.initialize(MEASUREMENT_ID);
  } catch (e) {
    console.error("GA Init Error:", e);
  }
}

const Layout = () => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin');
  const isDetailPage = location.pathname.startsWith('/mobile/');

  // Track Page Views
  React.useEffect(() => {
    if (MEASUREMENT_ID) {
      ReactGA.send({ hitType: "pageview", page: location.pathname + location.search });
    }
  }, [location]);

  return (
    <div className="app-wrapper">
      <ScrollToTop />
      {!isAdminRoute && <Navbar isDetailPage={isDetailPage} />}

      <div className="app-content animate-fade-slide-in" key={location.pathname}>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/cart" element={<CartPage />} />
          <Route path="/login" element={<LoginPage />} />
          <Route path="/about" element={<AboutUsPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/brands" element={<BrandsPage />} />
          <Route path="/compare" element={<ComparePage />} />
          <Route path="/deals" element={<DealsPage />} />
          <Route path="/sell" element={<SellPhonePage />} />
          <Route path="/repair" element={<RepairPhonePage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicyPage />} />
          <Route path="/terms-of-service" element={<TermsOfServicePage />} />
          <Route path="/admin" element={<AdminDashboard />} />
          <Route path="/admin/manage" element={<AdminDashboard />} />
          <Route path="/m/:shortId" element={<ShortLinkRedirect />} />
          <Route path="/mobile/:id" element={<MobileDetailPage />} />
          <Route path="/admin/edit/:id" element={<EditMobilePage />} />
          <Route path="*" element={<div>404 Not Found</div>} />
        </Routes>
      </div>

      {!isAdminRoute && <Footer />}

      {/* ✅ Global toast message container */}
      <ToastContainer position="bottom-center" autoClose={2000} />
    </div>
  );
};

function App() {
  React.useEffect(() => {
    console.log("🚀 JollyBaba Frontend v1.0.2 - Fresh Deployment Loaded");
    console.log("Build Time: " + new Date().toISOString());
  }, []);

  return (
    <HelmetProvider>
      <ThemeProvider>
        <UserTypeProvider>
          <SearchProvider>
            <Router>
              <Layout />
            </Router>
          </SearchProvider>
        </UserTypeProvider>
      </ThemeProvider>
    </HelmetProvider>
  );
}

export default App;
